import { render, staticRenderFns } from "./AsterikaUpsell.vue?vue&type=template&id=66172be4"
import script from "./AsterikaUpsell.vue?vue&type=script&lang=js"
export * from "./AsterikaUpsell.vue?vue&type=script&lang=js"
import style0 from "./AsterikaUpsell.vue?vue&type=style&index=0&id=66172be4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports